import axios from "axios";
import { apiRoot } from "../index";

export async function searchAddress(jwt, query) {
  let res = await axios.post(
    apiRoot + "/api/v1/geocode/search",
    {
      query,
    },
    {
      headers: {
        Authorization: jwt,
      },
    }
  );

  return res.data;
}

export async function getCoords(address, placeId = null) {
  let res = await axios.post(apiRoot + "/api/v1/geocode/get-coords", {
    address,
    place_id: placeId,
  });

  return res.data;
}
